<button
  *ngIf="options.closeButton"
  (click)="remove()"
  class="toast-close-button"
  aria-label="{{ 'Close' | translate }}"
  type="button"
>
  <span aria-hidden="true">&times;</span>
</button>

<div *ngIf="title" [attr.aria-label]="title" [class]="options.titleClass">
  {{ title }} <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
</div>

<div
  *ngIf="message && options.enableHtml"
  [class]="options.messageClass"
  [innerHTML]="message"
  aria-live="polite"
  role="alertdialog"
></div>

<div
  *ngIf="message && !options.enableHtml"
  [attr.aria-label]="message"
  [class]="options.messageClass"
  aria-live="polite"
  role="alertdialog"
>
  {{ message }}
</div>

<div *ngIf="!!buttons && buttons.length > 0" class="buttons">
  <button *ngFor="let button of buttons" [classList]="button.classList" (click)="action($event, button)">
    {{ button.title }}
  </button>
</div>

<div *ngIf="options.progressBar">
  <div [style.width]="width + '%'" class="toast-progress"></div>
</div>
